import React, { useState, useEffect } from 'react';

import { useBreadcrumbs, usePath } from '../../hooks';
import {
  useTeam,
  useSelector,
  useSeason,
  validateSelectorValue,
} from '../shared/hooks';
import OnOffMetrics from './OnOffMetrics';
import { useOnOffMetrics } from './useOnOffMetrics';
import { useTeamGames } from '../shared/hooks/useTeamGames';
import {
  seasonName,
  teamName,
  formatGameIds,
  checkIfNBA,
} from '../../lib/format';
import { getConferenceOptions } from '../LineupExplorer/LineupsFilter/filterOptions';

function createBreadcrumbs(team, season, pathTo) {
  return [
    { title: 'Teams', url: pathTo('teams') },
    { title: `[${seasonName(season)}] ${teamName(team)}`, url: pathTo('team') },
    { title: 'OnOff Metrics' },
  ];
}

const OnOffMetricsPage = ({ leagueId, seasonId, teamId }) => {
  const [sortKey, setSortKey] = useState();
  const [gameIds, setGameIds] = useState();
  const team = useTeam(teamId);
  const isNBA = checkIfNBA(team);
  const division = useSelector(getConferenceOptions(), !isNBA && 'in');
  const conference = useSelector(getConferenceOptions());
  const season = useSeason(seasonId);
  const teamGames = useTeamGames(
    leagueId,
    seasonId,
    team,
    null,
    150,
    true,
    false,
    validateSelectorValue(division, getConferenceOptions()),
    validateSelectorValue(conference, getConferenceOptions()),
  );
  const gameSelector = useSelector(teamGames);
  const filters = { game: gameSelector.value };
  const metrics = useOnOffMetrics(
    leagueId,
    seasonId,
    teamId,
    filters,
    sortKey,
    gameIds,
    validateSelectorValue(division, getConferenceOptions()),
    validateSelectorValue(conference, getConferenceOptions()),
  );
  const pathTo = usePath(leagueId, seasonId, teamId);

  const handleGameChange = gameIds => {
    if (gameIds) setGameIds(formatGameIds(gameIds));
    else setGameIds(null);
  };

  useBreadcrumbs(createBreadcrumbs, [team, season, pathTo]);
  useEffect(() => {
    if (sortKey) setSortKey(sortKey);
    else setSortKey(undefined);
    if (gameIds) setGameIds(formatGameIds(gameIds));
    else setGameIds(undefined);
  }, [sortKey, gameIds]);

  const handleSortChange = (court, stat) => {
    let descending = true;
    if (sortKey && sortKey[0] === court && sortKey[1] === stat) {
      descending = !sortKey[2];
    }
    setSortKey([court, stat, descending]);
  };

  return (
    <OnOffMetrics
      team={team}
      pathTo={pathTo}
      gameSelector={gameSelector}
      players={metrics}
      season={season}
      onSortChange={handleSortChange}
      sortKey={sortKey}
      games={teamGames}
      onGameChange={handleGameChange}
      division={division}
      conference={conference}
      isNBA={isNBA}
    />
  );
};

export default OnOffMetricsPage;
